import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: 10,
    cursor: "pointer",
    "& > div": {
      backgroundColor: "#EEF6FB",
      display: "flex",
      alignItems: "center",

      border: "1px solid #002B68",
      marginRight: 5,
      marginBottom: 10,
      padding: 5,
      "& p": {
        marginRight: 3,
        fontSize: 14,
      },
      "& svg": {
        cursor: "pointer",
        stroke: "#002B68",
        strokeWidth: 0.5,
      },
    },
    "& > p": {
      textDecoration: "underline",
      marginBottom: 15,
      marginLeft: "auto",
      cursor: "pointer",
      fontSize: 16,
    },
  },
}));

export default useStyles;
